import { render, staticRenderFns } from "./TextContributionMetadata.vue?vue&type=template&id=31412099"
import script from "./TextContributionMetadata.vue?vue&type=script&lang=js"
export * from "./TextContributionMetadata.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports